import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useDecorativeIconMotion } from '../../primitives/useIconMotion.js';
import type { AnimatedIconProps } from '../../primitives/types.js';

/** Key. The teeth slide out from under the bow on mount; on `active`
 *  re-key, the slide replays. Used as the password field prefix. */
export function IcnKey(props: AnimatedIconProps): ReactNode {
  const { active = true, ...rest } = props;
  const animate = useDecorativeIconMotion(active);
  return (
    <Svg {...rest} iconName="key" data-on={active ? 'true' : 'false'}>
      <circle cx="5.5" cy="8" r="2.5" />
      {/* Shaft + teeth, drawn left → right on mount. */}
      <g strokeDasharray="9" strokeDashoffset={animate ? '9' : '0'}>
        <path d="M8 8h6" />
        <path d="M11 8v2.2" />
        <path d="M13.5 8v1.6" />
        {animate && (
          <animate
            key={active ? 'on' : 'off'}
            attributeName="stroke-dashoffset"
            from="9"
            to="0"
            dur="0.55s"
            fill="freeze"
          />
        )}
      </g>
    </Svg>
  );
}
